const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

export const validateABN = (item: string) => {
  const abn = item.replace(/ /g, "");

  if (abn.length !== 11) {
    return false;
  }

  let total = 0;
  for (let i = 0; i < 11; i++) {
    total += weights[i] * (parseInt(abn[i]) - (i === 0 ? 1 : 0));
  }
  if (total === 0 || total % 89 !== 0) {
    return false;
  } else {
    return true;
  }
};
